import { createSlice } from "@reduxjs/toolkit";

const multiEntitySwitcherSlice = createSlice({
  name: "multiEntitySwitcherSlice",
  initialState: {
    switcherShouldBeEnabled: false,
    markerData: 0,
    cnfBtnClicked: true,
  },
  reducers: {
    enableSwitcher(state) {
      state.switcherShouldBeEnabled = true;
    },
    disableSwitcher(state) {
      state.switcherShouldBeEnabled = false;
    },
    triggerEntityChange(state) {
      state.markerData++;
    },
    triggerConfirmBtnClicked(state) {
      state.cnfBtnClicked++;
    },
  },
});

export const {
  enableSwitcher,
  disableSwitcher,
  triggerEntityChange,
  triggerConfirmBtnClicked,
} = multiEntitySwitcherSlice.actions;
export default multiEntitySwitcherSlice.reducer;
